/// <reference path="../../lib/app.d.ts" />

import logging from "../utils/log";

let retry = function retry(isDone, next)
{
	let current_trial = 0, max_retry = 50, is_timeout = false;
	let id = window.setInterval(
		function ()
		{
			if (isDone()) {
				window.clearInterval(id);
				next(is_timeout);
			}
			if (current_trial++ > max_retry) {
				window.clearInterval(id);
				is_timeout = true;
				next(is_timeout);
			}
		},
		10
	);
};

let isIE10OrLater = function (user_agent)
{
	let ua = user_agent.toLowerCase();
	if (ua.indexOf('msie') === 0 && ua.indexOf('trident') === 0) {
		return false;
	}
	let match = /(?:msie|rv:)\s?([\d.]+)/.exec(ua);

	if (match && parseInt(match[1], 10) >= 10) {
		return true;
	}

	let edge = /edge/.exec(ua);
	return !!(edge && edge[0] == "edge");
};

let TAG = "[PrivateMode]";

export function detect(callback)
{
	logging.log(TAG, "Private mode detection initialized...");

	if ("webkitRequestFileSystem" in window && window["webkitRequestFileSystem"])
	{
		logging.log(TAG, "Webkit...");
		// @ts-ignore
		window["webkitRequestFileSystem"](
			window["TEMPORARY"],
			1,
			() => {logging.log(TAG, "FS Ready"); callback(false)},
			() => {logging.log(TAG, "FS Error"); callback(true)});

		return;
	}

	else if ("indexedDB" in window && window["indexedDB"] && /Firefox/.test(window.navigator.userAgent))
	{
		logging.log(TAG, "Firefox with indexedDB...");
		try
		{
			let db = window.indexedDB.open('test');

			db.onerror = () => {
				logging.log(TAG, "DB.onerror");
				callback(true);
			};

			db.onsuccess = () => {
				logging.log(TAG, "DB.onsuccess", db.result);
				callback(!db.result);
			}
		}
		catch (e)
		{
			logging.log(TAG, "DB Exception", e);
			callback(true);
		}

		return;
	}

	else if (isIE10OrLater(window.navigator.userAgent))
	{
		logging.log(TAG, "IE>10");

		try {
			if (!window.indexedDB) {
				logging.log(TAG, "Has IndexedDB");
				callback(true);
				return;
			}
		} catch (e) {
			logging.log(TAG, "DB Exception", e);
			callback(true);
			return;
		}

		callback(false);
	}

	else if (window.localStorage && /Safari/.test(window.navigator.userAgent))
	{
		logging.log(TAG, "Safari");
		try {
			localStorage["setItem"]('test', "1");
			localStorage["removeItem"]('test');
			logging.log(TAG, "LS Working");
			callback(false);
		}
		catch (e) {
			logging.log(TAG, "LS Exception", e);
			callback(true);
		}
	}

	else {
		logging.log(TAG, "None of the tests was available");
		callback(null)
	}

	logging.log(TAG, "This should not happen!");
}
